import { render, staticRenderFns } from "./ModalAmbienteIdioma.vue?vue&type=template&id=a7f855c2&lang=pug"
import script from "./ModalAmbienteIdioma.vue?vue&type=script&lang=js"
export * from "./ModalAmbienteIdioma.vue?vue&type=script&lang=js"
import style0 from "./ModalAmbienteIdioma.vue?vue&type=style&index=0&id=a7f855c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports